import axios from "axios";
import moment from "moment";
import { Dispatch } from "redux";

import { parse, format, isValid } from "date-fns";

import {
  GET_LOCATION,
  GET_LOCATION_SUCCESS,
  GET_LOCATION_FAILURE,
  CommonActionTypes,
} from "../types/commonType";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });
API.defaults.withCredentials = true;

// export const getCsrfToken = async () => {
//     try {
//         const response = await API.get("/csrf-token", { withCredentials: true });
//         const csrfToken = response.data.csrf_token;
//         API.defaults.headers.common["X-CSRF-TOKEN"] = csrfToken;

//         return csrfToken; // Return the token if needed
//     } catch (error) {
//         console.error("Failed to fetch CSRF token:", error);
//         return null;
//     }
// };

export const getLocation =
  () => async (dispatch: Dispatch<CommonActionTypes>) => {
    try {
      dispatch({ type: GET_LOCATION, payload: [] });

      const response = await API.get("/locations");
      if (response.status) {
        dispatch({ type: GET_LOCATION_SUCCESS, payload: response.data });
      } else {
        dispatch({
          type: GET_LOCATION_FAILURE,
          payload: response.data.message,
        });
      }
    } catch (error: any) {
      dispatch({
        type: GET_LOCATION_FAILURE,
        payload: error?.response?.data?.message,
      });
    }
  };

export const countryCodes = [
  { code: "+1", country: "USA" },
  { code: "+44", country: "UK" },
  { code: "+91", country: "India" },
  { code: "+61", country: "Australia" },
  { code: "+81", country: "Japan" },
  { code: "+49", country: "Germany" },
  { code: "+33", country: "France" },
  { code: "+39", country: "Italy" },
  { code: "+86", country: "China" },
  { code: "+7", country: "Russia" },
  { code: "+55", country: "Brazil" },
  { code: "+34", country: "Spain" },
  { code: "+82", country: "South Korea" },
  { code: "+52", country: "Mexico" },
  { code: "+31", country: "Netherlands" },
  { code: "+46", country: "Sweden" },
  { code: "+41", country: "Switzerland" },
  { code: "+47", country: "Norway" },
  { code: "+27", country: "South Africa" },
  { code: "+92", country: "Pakistan" },
  { code: "+20", country: "Egypt" },
  { code: "+971", country: "United Arab Emirates" },
  { code: "+966", country: "Saudi Arabia" },
  { code: "+90", country: "Turkey" },
  { code: "+98", country: "Iran" },
  { code: "+32", country: "Belgium" },
  { code: "+48", country: "Poland" },
  { code: "+351", country: "Portugal" },
  { code: "+972", country: "Israel" },
  { code: "+62", country: "Indonesia" },
  { code: "+66", country: "Thailand" },
  { code: "+63", country: "Philippines" },
  { code: "+64", country: "New Zealand" },
  { code: "+1-242", country: "Bahamas" },
  { code: "+1-246", country: "Barbados" },
  { code: "+1-268", country: "Antigua and Barbuda" },
  { code: "+1-441", country: "Bermuda" },
  { code: "+1-649", country: "Turks and Caicos Islands" },
  { code: "+1-758", country: "Saint Lucia" },
  { code: "+1-767", country: "Dominica" },
  { code: "+1-784", country: "Saint Vincent and the Grenadines" },
  { code: "+1-868", country: "Trinidad and Tobago" },
  { code: "+1-876", country: "Jamaica" },
  { code: "+506", country: "Costa Rica" },
  { code: "+507", country: "Panama" },
  { code: "+595", country: "Paraguay" },
  { code: "+598", country: "Uruguay" },
  { code: "+591", country: "Bolivia" },
  { code: "+504", country: "Honduras" },
  { code: "+593", country: "Ecuador" },
  { code: "+673", country: "Brunei" },
  { code: "+374", country: "Armenia" },
  { code: "+994", country: "Azerbaijan" },
  { code: "+998", country: "Uzbekistan" },
  { code: "+380", country: "Ukraine" },
  { code: "+375", country: "Belarus" },
  { code: "+386", country: "Slovenia" },
  { code: "+382", country: "Montenegro" },
  { code: "+373", country: "Moldova" },
  { code: "+357", country: "Cyprus" },
  { code: "+370", country: "Lithuania" },
  { code: "+371", country: "Latvia" },
  { code: "+372", country: "Estonia" },
  { code: "+359", country: "Bulgaria" },
  { code: "+420", country: "Czech Republic" },
  { code: "+421", country: "Slovakia" },
  { code: "+30", country: "Greece" },
  { code: "+354", country: "Iceland" },
  { code: "+56", country: "Chile" },
  { code: "+57", country: "Colombia" },
  { code: "+58", country: "Venezuela" },
  { code: "+591", country: "Bolivia" },
  { code: "+94", country: "Sri Lanka" },
  { code: "+880", country: "Bangladesh" },
  { code: "+965", country: "Kuwait" },
  { code: "+973", country: "Bahrain" },
  { code: "+974", country: "Qatar" },
  { code: "+968", country: "Oman" },
  { code: "+964", country: "Iraq" },
  { code: "+963", country: "Syria" },
  { code: "+970", country: "Palestine" },
  { code: "+211", country: "South Sudan" },
  { code: "+251", country: "Ethiopia" },
  { code: "+254", country: "Kenya" },
  { code: "+255", country: "Tanzania" },
  { code: "+256", country: "Uganda" },
  { code: "+260", country: "Zambia" },
  { code: "+263", country: "Zimbabwe" },
  { code: "+225", country: "Ivory Coast" },
  { code: "+221", country: "Senegal" },
  { code: "+233", country: "Ghana" },
  { code: "+234", country: "Nigeria" },
  { code: "+243", country: "Democratic Republic of the Congo" },
  { code: "+220", country: "Gambia" },
  { code: "+229", country: "Benin" },
  { code: "+250", country: "Rwanda" },
  { code: "+237", country: "Cameroon" },
  { code: "+228", country: "Togo" },
  { code: "+239", country: "São Tomé and Príncipe" },
  { code: "+212", country: "Morocco" },
  { code: "+216", country: "Tunisia" },
  { code: "+218", country: "Libya" },
];

const convertTo12HourFormat = (time: string): string => {
  const [hour, minute] = time.split(":").map(Number);
  const period = hour >= 12 ? "PM" : "AM";
  let adjustedHour = hour % 12;
  adjustedHour = adjustedHour === 0 ? 12 : adjustedHour; // 12 should stay as 12, not 0
  const adjustedMinute = minute.toString().padStart(2, "0");
  return `${adjustedHour}:${adjustedMinute} ${period}`;
};

export const generateTimeOptions = (
  bookingStartTime: string,
  bookingEndTime: string,
  sameDayMinimumBookingGap = 0 // in hours
): string[] => {
  const timeOptions: string[] = [];

  if (!bookingStartTime || !bookingEndTime) {
    return timeOptions;
  }

  const timeToMinutes = (time: string) => {
    const [hour, minute] = time.split(":").map(Number);
    return hour * 60 + minute;
  };

  const startMinutesFromBooking = timeToMinutes(bookingStartTime);
  const endMinutes = timeToMinutes(bookingEndTime);
  let startMinutes: number;

  if (sameDayMinimumBookingGap > 0) {
    // Current time plus the booking gap
    const nowWithGap = moment().add(sameDayMinimumBookingGap, "hours");

    // Round up to next 30-minute block
    const minute = nowWithGap.minute();
    const roundedMinute = minute <= 30 ? (minute === 0 ? 0 : 30) : 0;
    const roundedTime = nowWithGap.clone().minute(roundedMinute).second(0);
    if (minute > 30) {
      roundedTime.add(1, "hour");
    }

    const nowMinutes = roundedTime.hour() * 60 + roundedTime.minute();
    startMinutes = Math.max(startMinutesFromBooking, nowMinutes);
  } else {
    startMinutes = startMinutesFromBooking; // Use start time as is
  }

  let time = startMinutes;
  while (time <= endMinutes) {
    const hours = Math.floor(time / 60)
      .toString()
      .padStart(2, "0");
    const minutes = (time % 60).toString().padStart(2, "0");
    timeOptions.push(convertTo12HourFormat(`${hours}:${minutes}`));
    time += 30;
  }

  return timeOptions;
};

export const BookingSteps = ["Rental", "Review", "Checkout", "Confirmation"];

export function formatToTwoDecimals(value: any) {
  const num = parseFloat(value);
  if (isNaN(num)) return "0.00";
  return num.toFixed(2);
}

export function formatDateWithTime(
  date: Date | null,
  time: string | ""
): string {
  try {
    if (!date || !time) return "";

    const timeFormats = ["HH:mm:ss", "HH:mm", "hh:mm a", "hh:mm:ss a"];

    let parsedTime: Date | null = null;

    for (const tf of timeFormats) {
      const tryParse = parse(time, tf, new Date());
      if (isValid(tryParse)) {
        parsedTime = tryParse;
        break;
      }
    }

    if (!parsedTime) return "";

    const merged = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      parsedTime.getHours(),
      parsedTime.getMinutes(),
      parsedTime.getSeconds()
    );

    return format(merged, "yyyy-MM-dd HH:mm");
  } catch (error) {
    return "";
  }
}
